import { createFileRoute, Outlet } from '@tanstack/react-router'
import { clientConfig } from './-config'
import './-theme.css'

export const Route = createFileRoute('/demo')({
  component: () => (
    <div data-client={clientConfig.id} className="contents">
      <Outlet />
    </div>
  ),
})
